const assert = require('assert');

const merge = require('lodash.merge');

const {get, post, patch, del, gql} = require('./agent');

module.exports = (global_options) => {
  return {
    create: (data, local_options) => {
      const options = merge({}, global_options, local_options);
      return post('/deals', data, options);
    },
    get: (id, local_options) => {
      const options = merge({}, global_options, local_options);
      return get(`/deals/${id}`, options);
    },
    allocate: (id, data, local_options) => {
      const options = merge({}, global_options, local_options);
      return post(`/deals/${id}/allocations`, data, options);
    },
    invites: (id, local_options) => {
      const options = merge({}, global_options, local_options);
      return get(`/deals/${id}/invites`, options);
    },
    finalize: (id, local_options) => {
      const options = merge({}, global_options, local_options);
      const query = `
        mutation M {
          deal: transitionToFinalizing(id:  "${id}") {
            id
            status
          }
        }
      `;
      return gql(query, null, options);
    },
    finalized: (id, local_options) => {
      const options = merge({}, global_options, local_options);
      const query = `
        mutation M {
          deal: transitionToFinalized(id:  "${id}") {
            id
            status
          }
        }
      `;
      return gql(query, null, options);
    },
    closed: (id, local_options) => {
      const options = merge({}, global_options, local_options);
      const query = `
        mutation M {
          deal: transitionToClosed(id:  "${id}") {
            id
            status
          }
        }
      `;
      return gql(query, null, options);
    },
    lead_allocate: (id, allocations, local_options) => {
      const options = merge({}, global_options, local_options);
      const query = `
        mutation M ($allocations: [AllocationAmount]) {
          allocations: allocateDeal(id: "${id}", allocations: $allocations) {
            id
            investment {
              allocated
            }
          }
        }
      `;
      return gql(query, {allocations}, options);
    },
    unsigned: (id, local_options) => {
      const options = merge({}, global_options, local_options);
      return get(`/deals/${id}/documents_closing`, options);
    },
  }
}



// WEBPACK FOOTER //
// ../covert/deals.js